/**
 * 수집 채널 열넷 — 공개 지면(랜딩 `/` 검색칸 아래 · 소개 `/intro` 첫 화면 · 수집 채널 구역)이 같은 목록을 쓴다.
 * 채널 표기는 영문(용어 표) · `platformId` 는 `PlatformIcon` 의 열쇠다.
 */
export const COLLECTION_CHANNELS = [
  { name: 'Instagram', platformId: 'instagram' },
  { name: 'TikTok', platformId: 'tiktok' },
  { name: 'YouTube', platformId: 'youtube' },
  { name: 'Threads', platformId: 'threads' },
  { name: 'X', platformId: 'x' },
  { name: '네이버 블로그', platformId: 'naverblog' },
  { name: '네이버 카페', platformId: 'navercafe' },
  { name: '네이버 지식인', platformId: 'naverkin' },
  { name: 'DC인사이드', platformId: 'dcinside' },
  { name: '더쿠', platformId: 'theqoo' },
  { name: '뽐뿌', platformId: 'ppomppu' },
  { name: 'Reddit', platformId: 'reddit' },
  { name: 'LIPS', platformId: 'lips' },
  { name: '@cosme', platformId: 'atcosme' },
] as const;
